//action
import {
    GET_EMERGENCY_DTRF_LIST,
    GET_EMERGENCY_DTRF_LIST_FAIL,
    GET_EMERGENCY_DTRF_LIST_SUCCESS,
    GET_EMERGENCY_DTRF_LIST_RESET
} from "../action/getEmergencyDtrfListAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    list: [],
    pagination: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_EMERGENCY_DTRF_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_EMERGENCY_DTRF_LIST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_EMERGENCY_DTRF_LIST_SUCCESS:
            console.log("myresponse", action.response)
            return {
                ...state,
                apiState: "success",
                list: action.response.data.data.result,
                pagination: action.response.data.data.pagination,
            }
        case GET_EMERGENCY_DTRF_LIST_RESET:
            return initialState
        default:
            return state
    }
}